import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers, createStore } from "redux";
import { filmReducer } from "./film";
import { userReducer } from "./user";
import { friendsReducer } from "./friends";
import { settingsReducer } from "./settings";

const rootReducer = combineReducers({
  film: filmReducer,
  user: userReducer,
  settings: settingsReducer,
  friends: friendsReducer
});

const persistConfig = {
  key: "root",
  storage
};

export type RootState = ReturnType<typeof rootReducer>;

declare module "react-redux" {
  interface DefaultRootState extends RootState {}
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
